import React, { forwardRef } from "react";

import {
    getTiktokAuthUrl,
    tiktokAuthorize,
} from "../../../../helpers/tiktok-lead/tiktok-lead";
import "../../../../css/createTikTokDestination.css";
import SwalAlertComp from "../../../SwalAlert";
import { useSelector } from "react-redux";
import LoginButton from "../../../molecules/LoginButton";

const TiktokLogin = forwardRef(
    ({ setIsLoading, isLoading, onLogin, handleAuth = true, label }, ref) => {
        const language = useSelector((state) => state.languagesState.languages);

        const getAuthUrl = async () => {
            setIsLoading?.(true);
            const response = await getTiktokAuthUrl();
            if (response.status) {
                return response?.data?.auth_url ?? null;
            }
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message,
                icon: "error",
            });
            setIsLoading?.(false);
            return null;
        };

        const handleSuccess = async ({ code, state }) => {
            if (!handleAuth) {
                onLogin({ code, state });
                return;
            }

            const response = await tiktokAuthorize({ code, state });
            if (response.status) {
                onLogin({ state: response?.data?.state });
                return;
            }
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message,
                icon: "error",
            });
            setIsLoading?.(false);
        };

        return (
            <LoginButton
                ref={ref}
                code="tiktok"
                className="mb-3 tiktok-btn"
                getAuthUrl={getAuthUrl}
                paramNames={["code", "state"]}
                requireAllParams
                onSuccess={handleSuccess}
                onError={() => setIsLoading?.(false)}
                onAuthUrlError={() => setIsLoading?.(false)}
                logoSrc="/assets/images/tiktok.png"
                buttonText={
                    label ??
                    language?.destination_modal?.continue_with_tiktok ??
                    "Continue with Tiktok"
                }
                isLoadingExternal={isLoading}
            />
        );
    },
);

export default TiktokLogin;
